import { Component, Input } from '@angular/core';

/**
 * Component to render an icon
 */
@Component({
    selector: 'area-menu-icon',
    templateUrl: './AreaMenuIconView.html'
})
export class AreaMenuIconComponent {
    public static $name: string = 'areaMenuIcon';

    @Input() public icon: string;
}
